<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="app-main-inner-row" style="height: 100%;min-height: 870px;">
        <div class="section grid-wrapper" style="width:15%;min-width:190px;border:1px solid #ccc;display: flex;cursor: pointer">
          <cargo-ag-grid
            :show-side-bar="false"
            :grid-options="trackingTree.gridOptions"
            :column-defs="trackingTree.columnDefs"
            :row-data="trackingTree.rowData"
            style="width:100%;height:100%;min-height: 500px;"
          />
        </div>
        <div style="min-width:85%;border:1px solid #ccc;display: flex;height: 100%">
          <tracking v-if="optModule.tracking" ref="trackingModule" :tree-node="currentState.treeNode" :tracking-tree="trackingTree" @addTrackingDetail="toAddDetail4Tracking" @refreshTree="toRefreshTree" />
          <tracking-detail v-if="optModule.trackingDetail" ref="trackingDetailModule" :tree-node="currentState.treeNode" :tracking-list="trackingTree.rowData" @refreshTree="toRefreshTree" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import tracking from './business/tracking'
import tracking from './business/tracking'
import trackingDetail from './business/trackingDetail'
import { getTrackingTree } from '@/api/sysManage/baseConfig/businessManage'
import { getLoading } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'BusinessStatusManagement',
  components: {
    tracking, trackingDetail
  },
  filters: {},
  data() {
    return {
      loading: false,
      currentState: {
        treeNode: {} // 当前点击的节点
      },
      optModule: { // 操作
        tracking: false,
        trackingDetail: false
      },
      trackingTree: {
        columnDefs: [],
        rowData: [],
        gridOptions: {
          rowSelection: 'single',
          groupDefaultExpanded: 1,
          suppressRowClickSelection: false,
          treeData: true,
          getDataPath: (data) => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('SystemMaintenance.Name'),
            width: 280,
            cellRendererParams: {
              // suppressCount: true,
              suppressDoubleClickExpand: true,
              innerRenderer: (params) => {
                if (params.data.type === 1) {
                  return params.data.chineseName
                }
                if (SystemConstants.getCommonState(params.data.parentUuid, SystemConstants.LOBS)) {
                  return `${params.data.level}.` + params.data.chineseName
                }
                return `${params.data.level}.` + params.data.chineseName
              },
              checkbox: (params) => {
                return false
              }
            }
          },
          onRowClicked: this.onRowClick
        }
      }
    }
  },
  async mounted() {
    await this.fetchTreeData()
    this.optModule.tracking = true
    // 默认选中第一行
    this.trackingTree.gridOptions.api.setFocusedCell(0, this.trackingTree.gridOptions.api.columnController.getAllDisplayedColumns()[0])
    const cell = this.trackingTree.gridOptions.api.getFocusedCell()
    const nodes = this.trackingTree.gridOptions.api.rowModel.rowsToDisplay
    const node = (cell && nodes.length > 0) ? nodes.find(node => node.rowIndex === cell.rowIndex) : null
    this.onRowClick({ node })
  },
  methods: {
    async fetchTreeData() {
      this.loading = getLoading()
      return getTrackingTree().then(res => {
        this.trackingTree.rowData = res.data.filter(row => {
          // 截取path，过滤出五大业务及其叶子节点
          const arr = row.path.split(',')
          if (arr.length > 1) {
            return SystemConstants.getCommonState(arr[0], SystemConstants.LOBS)
          }
          return row.root
        })
      }).finally(() => {
        this.loading.close()
      })
    },
    toAddDetail4Tracking(data) {
      // tracking node 新建状态明细
      this.trackingTree.gridOptions.api.forEachNode((node, index) => {
        if (data.uuid === node.data.uuid) {
          this.toMountView(node.data, node, 'trackingDetail')
        }
      })
    },
    async toRefreshTree({ action, data }) {
      const oldExpandUuidSet = new Set()
      this.trackingTree.gridOptions.api.forEachNode(node => {
        if (node.expanded) oldExpandUuidSet.add(node.data.uuid)
      })
      await this.fetchTreeData()
      const nodeMap = this.getNodeByUuid(data.uuid, data.parentUuid)
      const selectedNode = nodeMap.get(data.uuid)
      const expandedNode = nodeMap.get(data.parentUuid)

      const goExpandNodeMap = this.getNodeByUuid(...oldExpandUuidSet)
      // 应该遍历展开(保持原有展开状态)
      for (const node of goExpandNodeMap.values()) {
        node.setExpanded(true)
      }
      selectedNode.setSelected(true)
      expandedNode.setExpanded(true)
      this.toMountView(selectedNode.data, selectedNode, [1, 2].includes(selectedNode.data.type) ? 'tracking' : 'trackingDetail')
    },
    getNodeByUuid(...uuids) {
      const nodeMap = new Map()
      this.trackingTree.gridOptions.api.forEachNode((node, index) => {
        if (uuids.includes(node.data.uuid)) {
          nodeMap.set(node.data.uuid, node)
        }
      })
      return nodeMap
    },
    onRowClick(event) {
      this.toMountView(event.node.data, event.node, [1, 2].includes(event.node.data.type) ? 'tracking' : 'trackingDetail')
    },
    toMountView(rowData, node, viewName) {
      this.optModule.tracking = false
      this.optModule.trackingDetail = false
      this.$nextTick(() => {
        this.currentState.treeNode = { ...rowData, hasChild: node ? node.hasChildren() : false }
        if (viewName === 'tracking') {
          this.optModule.tracking = true
          this.$nextTick(() => {
            this.$refs['trackingModule'].onShow()
          })
        } else if (viewName === 'trackingDetail') {
          this.optModule.trackingDetail = true
          this.$nextTick(() => {
            this.$refs['trackingDetailModule'].onShow(this.currentState.treeNode.uuid, node.allChildrenCount)
          })
        } else {
          // error
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
